import React, { useEffect, useState } from "react";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import BellIcon from "../../assets/icons/BellIcon";
import BookmarkIcon from "../../assets/icons/BookmarkIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";
import SearchIcon from "../../assets/icons/SearchIcon";
import Checkbox from "../../common/Checkbox";

import Save from "../../assets/images/save.png";

import "./index.scss";
import {
  getKeyFromText,
  getUserIdFromLocalStorage,
} from "../../utils/Utilities";
import { updateCaseList } from "../../services/cases";
import { Circles } from "react-loader-spinner";
import { useSelector } from "react-redux";
import CasesDropdownMenu from "./CasesDropdown";
import { useTranslation } from "react-i18next";
import FormattedDate from "./../../utils/TabelDateFormat";
const DeletedCasesList = ({
  data,
  handleRefresh,
  search,
  handleSearch,
  searchFilterState,
  handleFilterStateActive,
  entireCasesText,
  handleEntireCasesText,
  handleSetConsultantFilter,
  selectedConsultant,
  consultantsList,
  selectedConsultantName,
}) => {
  let uID = getUserIdFromLocalStorage();
  const { t, i18n } = useTranslation();
  const loading = useSelector((state) => state.casesState.cases.loading);
  let navigate = useNavigate();
  const [openConsultantFilter, setOpenConsultantFilter] = useState(false);

  const [list, setList] = useState([]);
  useEffect(() => {
    setList(
      data
        ?.filter((item) => item.isDeleted)
        ?.map((item) => ({ ...item, isChecked: false } || []))
    );
  }, [data]);
  const handleChangeCheck = (e) => {
    setList(
      list.map((item) => {
        if (item.caseId == e.target.id)
          return { ...item, isChecked: !item.isChecked };
        return item;
      })
    );
  };

  const handleClickBookmark = (e, item) => {
    e.stopPropagation();
    handleUpdateList([{ ...item, isMarked: !item.isMarked }]);
  };
  const handleUpdateList = async (payload) => {
    const result = await updateCaseList(payload, uID);
    if (result?.success) {
      handleRefresh();
    }
  };
  const restoreDeleteItems = async () => {
    let updatedList = list;
    for (let i = 0; i < updatedList.length; i++) {
      const elementI = updatedList[i];
      if (elementI.isChecked) {
        elementI.isChecked = false;
        elementI.isDeleted = false;
      }
    }
    setList([...updatedList]);
    const result = await updateCaseList(updatedList, uID);

    if (result?.success) {
      handleRefresh();
    }
  };
  const handleCloseDropdown = () => {
    setOpenConsultantFilter(false);
  };
  return (
    <>
      <div className="cases">
        <div className="input-wrapper">
          <input
            placeholder={t(getKeyFromText("Name, Surname, date of birth"))}
            className="custom-input"
            value={search}
            onChange={(e) => {
              handleSearch(e.target.value);
            }}
          />
          <SearchIcon
            className="search-icon"
            onClick={() => {
              handleRefresh();
              handleFilterStateActive();
            }}
          />
        </div>
        <div style={{ position: "relative" }}>
          <button
            type="button"
            className={selectedConsultant ? "stroke filter-btn" : "filter-btn"}
            disabled={searchFilterState}
            onClick={() => {
              setOpenConsultantFilter((pre) => !pre);
            }}
          >
            Filter
          </button>

          {openConsultantFilter && (
            <CasesDropdownMenu
              handleSubmit={(value) => {
                handleSetConsultantFilter(value);
                handleCloseDropdown();
                handleRefresh();
              }}
              handleClose={handleCloseDropdown}
              list={consultantsList}
              selectedValue={selectedConsultant}
            />
          )}
        </div>
        <h5
          onClick={() => {
            handleSearch("");
            handleRefresh();
            handleEntireCasesText();
            handleSetConsultantFilter();
          }}
          style={{
            pointerEvents: entireCasesText ? "all" : "none",
            cursor: "pointer",
          }}
        >
          {entireCasesText ? selectedConsultantName : ""}
        </h5>
      </div>
      <div
        className="cases-table"
        style={{
          minHeight: "500px",
          overflow: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: loading && "center",
        }}
      >
        {loading ? (
          <Circles color="#dfc8db" height={80} width={80} />
        ) : (
          <TableContainer component={Paper}>
            <div className="delete-filters-btn">
              <div
                className="save-icon"
                style={{
                  cursor: "pointer",
                  pointerEvents: list.every((item) => !item.isChecked)
                    ? "none"
                    : "all",
                  opacity: list.every((item) => !item.isChecked) ? "0.6" : "1",
                  backgroundColor: list.every((item) => !item.isChecked)
                    ? "#a5a5a5"
                    : "#dfc8db",
                }}
                onClick={restoreDeleteItems}
              >
                <img src={Save} alt="icon" width="18px" />
                <span>{t(getKeyFromText("Restore"))}</span>
              </div>
              <div className="delete-icon">
                <DeleteIcon
                  style={{
                    width: "22px",
                    margin: "10px 2px 10px 10px",
                  }}
                />
                <span>{t(getKeyFromText("Deleted forever"))}</span>
              </div>
            </div>
            <Table
              sx={{ minWidth: 650, maxHeight: "300px", overflow: "auto" }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell />
                  <TableCell>{t(getKeyFromText("Name"))}</TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Date Of Birth"))}
                  </TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Email"))}
                  </TableCell>
                  <TableCell align="left" />
                  <TableCell align="left">
                    {t(getKeyFromText("Updated date"))}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item) => {
                  return (
                    <TableRow
                      key={item.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        ...(item.isChecked && {
                          backgroundColor: "color.magentaLight2",
                        }),
                      }}
                    >
                      <TableCell component="th" scope="row">
                        <div
                          style={{
                            marginTop: "-8px",
                            display: "flex",
                            alignItems: "left",
                          }}
                        >
                          <Checkbox
                            id={item.caseId}
                            checked={item.isChecked}
                            onChange={handleChangeCheck}
                            theme={item.isChecked ? "checked" : "secondary"}
                          />
                        </div>
                      </TableCell>
                      <TableCell align="left">
                        <BookmarkIcon
                          style={{
                            width: "20px",
                            display: "flex",
                            alignItems: "center",
                            fill: item.isMarked ? "#FFD76C" : "none",
                            cursor: "pointer",
                          }}
                          color={item.isMarked ? "#FFD76C" : "#A3A3A3"}
                          onClick={(e) => {
                            handleClickBookmark(e, item);
                          }}
                        />
                      </TableCell>
                      <TableCell align="left">
                        {item?.clientName || ""}
                      </TableCell>
                      <TableCell align="left">
                        {item?.clientDateOfBirth || ""}
                      </TableCell>
                      <TableCell align="left" className="cases-email">
                        {item?.clientEmail || ""}
                      </TableCell>
                      <TableCell align="left">
                        <div className="icon-avatar">
                          <BellIcon fill="#FF996C" style={{ width: "12px" }} />
                        </div>
                      </TableCell>
                      <TableCell align="left">
                        {/* {item.updatedDateByClient?.slice(0, 10)} */}
                        <FormattedDate
                          date={item?.updatedDateByClient}
                          language={i18n.language}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </>
  );
};

export default DeletedCasesList;
